import { TextractServiceException as __BaseException } from "./TextractServiceException";
export class AccessDeniedException extends __BaseException {
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        this.name = "AccessDeniedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export var FeatureType;
(function (FeatureType) {
    FeatureType["FORMS"] = "FORMS";
    FeatureType["QUERIES"] = "QUERIES";
    FeatureType["SIGNATURES"] = "SIGNATURES";
    FeatureType["TABLES"] = "TABLES";
})(FeatureType || (FeatureType = {}));
export var ContentClassifier;
(function (ContentClassifier) {
    ContentClassifier["FREE_OF_ADULT_CONTENT"] = "FreeOfAdultContent";
    ContentClassifier["FREE_OF_PERSONALLY_IDENTIFIABLE_INFORMATION"] = "FreeOfPersonallyIdentifiableInformation";
})(ContentClassifier || (ContentClassifier = {}));
export var BlockType;
(function (BlockType) {
    BlockType["CELL"] = "CELL";
    BlockType["KEY_VALUE_SET"] = "KEY_VALUE_SET";
    BlockType["LINE"] = "LINE";
    BlockType["MERGED_CELL"] = "MERGED_CELL";
    BlockType["PAGE"] = "PAGE";
    BlockType["QUERY"] = "QUERY";
    BlockType["QUERY_RESULT"] = "QUERY_RESULT";
    BlockType["SELECTION_ELEMENT"] = "SELECTION_ELEMENT";
    BlockType["SIGNATURE"] = "SIGNATURE";
    BlockType["TABLE"] = "TABLE";
    BlockType["TITLE"] = "TITLE";
    BlockType["WORD"] = "WORD";
})(BlockType || (BlockType = {}));
export var EntityType;
(function (EntityType) {
    EntityType["COLUMN_HEADER"] = "COLUMN_HEADER";
    EntityType["KEY"] = "KEY";
    EntityType["VALUE"] = "VALUE";
})(EntityType || (EntityType = {}));
export var RelationshipType;
(function (RelationshipType) {
    RelationshipType["ANSWER"] = "ANSWER";
    RelationshipType["CHILD"] = "CHILD";
    RelationshipType["COMPLEX_FEATURES"] = "COMPLEX_FEATURES";
    RelationshipType["MERGED_CELL"] = "MERGED_CELL";
    RelationshipType["TITLE"] = "TITLE";
    RelationshipType["VALUE"] = "VALUE";
})(RelationshipType || (RelationshipType = {}));
export var SelectionStatus;
(function (SelectionStatus) {
    SelectionStatus["NOT_SELECTED"] = "NOT_SELECTED";
    SelectionStatus["SELECTED"] = "SELECTED";
})(SelectionStatus || (SelectionStatus = {}));
export var TextType;
(function (TextType) {
    TextType["HANDWRITING"] = "HANDWRITING";
    TextType["PRINTED"] = "PRINTED";
})(TextType || (TextType = {}));
export class BadDocumentException extends __BaseException {
    constructor(opts) {
        super({
            name: "BadDocumentException",
            $fault: "client",
            ...opts,
        });
        this.name = "BadDocumentException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadDocumentException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class DocumentTooLargeException extends __BaseException {
    constructor(opts) {
        super({
            name: "DocumentTooLargeException",
            $fault: "client",
            ...opts,
        });
        this.name = "DocumentTooLargeException";
        this.$fault = "client";
        Object.setPrototypeOf(this, DocumentTooLargeException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class HumanLoopQuotaExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "HumanLoopQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "HumanLoopQuotaExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, HumanLoopQuotaExceededException.prototype);
        this.ResourceType = opts.ResourceType;
        this.QuotaCode = opts.QuotaCode;
        this.ServiceCode = opts.ServiceCode;
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InternalServerError extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServerError";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerError.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InvalidParameterException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidParameterException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidParameterException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidParameterException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InvalidS3ObjectException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidS3ObjectException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidS3ObjectException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidS3ObjectException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ProvisionedThroughputExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "ProvisionedThroughputExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "ProvisionedThroughputExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ProvisionedThroughputExceededException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ThrottlingException extends __BaseException {
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "server",
            ...opts,
        });
        this.name = "ThrottlingException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class UnsupportedDocumentException extends __BaseException {
    constructor(opts) {
        super({
            name: "UnsupportedDocumentException",
            $fault: "client",
            ...opts,
        });
        this.name = "UnsupportedDocumentException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnsupportedDocumentException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export var ValueType;
(function (ValueType) {
    ValueType["DATE"] = "DATE";
})(ValueType || (ValueType = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["FAILED"] = "FAILED";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
    JobStatus["SUCCEEDED"] = "SUCCEEDED";
})(JobStatus || (JobStatus = {}));
export class InvalidJobIdException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidJobIdException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidJobIdException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidJobIdException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InvalidKMSKeyException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidKMSKeyException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidKMSKeyException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidKMSKeyException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class IdempotentParameterMismatchException extends __BaseException {
    constructor(opts) {
        super({
            name: "IdempotentParameterMismatchException",
            $fault: "client",
            ...opts,
        });
        this.name = "IdempotentParameterMismatchException";
        this.$fault = "client";
        Object.setPrototypeOf(this, IdempotentParameterMismatchException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class LimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LimitExceededException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export const S3ObjectFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const HumanLoopDataAttributesFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const HumanLoopConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QueryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QueriesConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeDocumentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BoundingBoxFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PointFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GeometryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RelationshipFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BlockFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DocumentMetadataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const HumanLoopActivationOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeDocumentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeExpenseRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExpenseCurrencyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExpenseGroupPropertyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExpenseDetectionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExpenseTypeFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExpenseFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LineItemFieldsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LineItemGroupFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExpenseDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeExpenseResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeIDRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const NormalizedValueFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeIDDetectionsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IdentityDocumentFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IdentityDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnalyzeIDResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectDocumentTextRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectDocumentTextResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectedSignatureFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SplitDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UndetectedSignatureFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DocumentGroupFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DocumentLocationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LendingDetectionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LendingFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SignatureDetectionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LendingDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExtractionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetDocumentAnalysisRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const WarningFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetDocumentAnalysisResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetDocumentTextDetectionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetDocumentTextDetectionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetExpenseAnalysisRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetExpenseAnalysisResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLendingAnalysisRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PredictionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PageClassificationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LendingResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLendingAnalysisResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLendingAnalysisSummaryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LendingSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLendingAnalysisSummaryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const NotificationChannelFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OutputConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartDocumentAnalysisRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartDocumentAnalysisResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartDocumentTextDetectionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartDocumentTextDetectionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartExpenseAnalysisRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartExpenseAnalysisResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartLendingAnalysisRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartLendingAnalysisResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
